<script>
import { ref } from 'vue';
import { useStore } from 'vuex';
import { ADMIN_TICKETS } from '@/store/types';
import ticketsApi from '@/services/apis/admin/tickets.api';

export default {
  props: {
    page: {
      type: Number,
      default: 1,
    },
    per_page: {
      type: Number,
      default: 10,
    },
    search: {
      type: String,
      default: '',
    },
    search_status: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const store = useStore();
    const query = ref(null);
    query.value = ticketsApi.useTicketsQuery({
      page: props.page,
      per_page: props.per_page,
      search: props.search,
      search_status: props.search_status,
    });
    if (query.value) {
      store.commit(ADMIN_TICKETS.SET_TICKETS_QUERY, query);
    }
    return { query };
  },
};
</script>
